export const TOPOLOGY_WORKBENCH_THREAD_TAG = 'topology_workbench';

const normalizeThreadTag = (value: string): string => value.trim().toLowerCase();

export const hasChatThreadTag = (
  thread: {
    tags?: string[] | null;
  } | null | undefined,
  tag: string
): boolean => {
  const normalizedTag = normalizeThreadTag(tag);
  return (thread?.tags ?? []).some((value) => normalizeThreadTag(value) === normalizedTag);
};

export const mergeChatThreadTags = (
  currentTags: string[] | null | undefined,
  nextTags: string[]
): string[] => {
  const merged = new Map<string, string>();
  for (const value of [...(currentTags ?? []), ...nextTags]) {
    const trimmed = value.trim();
    if (!trimmed) {
      continue;
    }
    const key = normalizeThreadTag(trimmed);
    if (!merged.has(key)) {
      merged.set(key, trimmed);
    }
  }
  return [...merged.values()];
};
